var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandLessRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.39307L15 12.3931L13.8281 13.5649L10 9.73682L6.17188 13.5649L5 12.3931L10 7.39307Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLessRegular);
export default __webpack_public_path__ + "static/media/ExpandLessRegular.a3130691d1bc0d6e79dc60d21f939483.svg";
export { ForwardRef as ReactComponent };